export const CODE_EDITOR_EVENTS = {
    onInit: 'onInit',
    onChange: 'onChange',
    onTouched: 'onTouched'
}